var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "technical-list-container", class: { show: _vm.isOpen } },
    _vm._l(_vm.options, function(option) {
      return option.visible
        ? _c(
            "div",
            {
              key: option.layer,
              staticClass: "technical-container",
              class: { selected: _vm.isSelected(option.layer) },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("select", option)
                }
              }
            },
            [
              _c(
                _vm.isSelected(option.layer) ? option.filledIcon : option.icon,
                { tag: "component", staticClass: "technical-svg" }
              ),
              _vm._v(" "),
              option.instructions
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "span",
                                  _vm._g(
                                    _vm._b(
                                      { staticClass: "technical-text" },
                                      "span",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_vm._v(_vm._s(option.label))]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(option.instructions))])
                    ]
                  )
                : _c("span", { staticClass: "technical-text" }, [
                    _vm._v(_vm._s(option.label))
                  ])
            ],
            1
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dcd240c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dcd240c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Toolbars/CreateObjects/ItemOptionsMenu.vue
// module id = null
// module chunks = 